import { Box, Button, Grid, styled, Theme, Typography } from '@mui/material';

export const Container = styled(Box)<{ $showEmptyComponent?: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px 24px;
  width: ${({ $showEmptyComponent }: { $showEmptyComponent: boolean }) =>
    $showEmptyComponent ? '600px' : '1280px'};
  height: ${({ $showEmptyComponent }: { $showEmptyComponent: boolean }) =>
    $showEmptyComponent ? '250px' : '820px'};
`;

export const FluidWidthColumn = styled(Grid)`
  height: 60vh;
  overflow-y: scroll;
`;

export const HeaderWrapper = styled(Box)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderTitle = styled('h2')`
  font-size: 20px;
  font-weight: 500;
  margin: 0;
`;

export const SearchAndCloseIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const NoComponentsWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const CreateComponentButton = styled(Button)(
  ({ theme, disabled }) => `
  min-width: 126px;
  border: 1px solid;
  color: ${theme.palette.primary.main};
  background-color: white;

  & path {
    fill: ${
      disabled ? theme.palette.brand.disable : theme.palette.primary.main
    };
  }
`,
);

export const SearchTerms = styled(Box)`
  padding: 5px 0;
`;

export const ChipSpacer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;

export const NoResultsWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  min-height: 400px;
`;

export const NoResultsImage = styled('img')`
  width: 200px;
  height: 161px;
  margin-bottom: 24px;
`;

export const NoResultsText = styled(Typography)(
  ({ theme }: { theme: Theme }) => `
  font-size: 16px;
  color: ${theme.palette.text.secondary};
  text-align: center;
`,
);
